export enum NotificationStatusDto {
    NotSent = 'NotSent',
    Sent = 'Sent',
    Read = 'Read',
}
